import { render, staticRenderFns } from "./ratifyAccord.vue?vue&type=template&id=0b482180&scoped=true"
import script from "./ratifyAccord.vue?vue&type=script&lang=js"
export * from "./ratifyAccord.vue?vue&type=script&lang=js"
import style0 from "./ratifyAccord.vue?vue&type=style&index=0&id=0b482180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b482180",
  null
  
)

export default component.exports